import { isGigPaused } from '../gigStatus';

export function shouldShowSelectPackage({gigStatus, traffiqed, isOnVacation}) {
    return !(isGigPaused(gigStatus, traffiqed) || isOnVacation);
}
